import React, { useContext, useMemo } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { APPOINTMENTS_DATE_FORMAT } from '../../Constants';
import { AccountContext } from '../../Accounts';
import { DataTypeContext } from '../../DataTypes';

const BookingConfirmed = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const { clientId, selectedAppointmentSlot, selectedAppointmentLocation } = useContext(AccountContext);
    const { dataTypes } = useContext(DataTypeContext);

    const whatToBringText = dataTypes?.whatToBringMessage || t('bookingConfirmed.whatToBringText');

    const appointmentDateTime = useMemo(() => {
        const dateTime = moment(selectedAppointmentSlot?.availableDateTime);
        return dateTime.isValid() ? dateTime.format(APPOINTMENTS_DATE_FORMAT) : '';
    }, [selectedAppointmentSlot]);

    const appointmentProgram = location?.state?.selectedProgramName
        || selectedAppointmentSlot?.programName
        || t('intake.notFilledValue');

    return (
        <Col md={6} sm={12} className="mx-auto">
            <div className="card shadow-sm rounded p-4">
                <div className="text-center mb-4">
                    <div className="display-4 text-dark" aria-hidden="true">✓</div>
                    <h3 className="mt-2 mb-3">{t('bookingConfirmed.heading')}</h3>
                    <p className="text-muted mb-0">{t('bookingConfirmed.subheading')}</p>
                </div>

                <div className="border rounded p-4 mb-4">
                    <h4 className="h3 mb-3">{t('bookingConfirmed.detailsHeading')}</h4>

                    <p className="text-muted mb-1">{t('bookingConfirmed.dateTimeLabel')}</p>
                    <p className="fw-semibold mb-3">{appointmentDateTime}</p>

                    <p className="text-muted mb-1">{t('bookingConfirmed.locationLabel')}</p>
                    <p className="fw-semibold mb-3">{selectedAppointmentLocation?.nameWithAddress || ''}</p>

                    <p className="text-muted mb-1">{t('appointment.program')}</p>
                    <p className="fw-semibold mb-3">{appointmentProgram}</p>

                    <p className="text-muted mb-1">{t('bookingConfirmed.clientIdLabel')}</p>
                    <p className="fw-semibold mb-0">{clientId}</p>
                </div>

                <div className="border rounded p-3 mb-4 bg-primary-opacity-10">
                    <p><strong>{t('bookingConfirmed.whatToBringLabel')}</strong></p>
                    <span dangerouslySetInnerHTML={{ __html: whatToBringText }}></span>
                </div>

                <div className="booking-confirmed-actions">
                    <div className="mb-2">
                        <Button as={Link} to="/upcoming-appointments" variant="primary" className="w-100 py-2">
                            {t('bookingConfirmed.viewUpcomingButton')}
                        </Button>
                    </div>
                    <div>
                        <Button as={Link} to="/dashboard" variant="outline-secondary" className="w-100 py-2">
                            {t('dashboard.return')}
                        </Button>
                    </div>
                </div>
            </div>

            <p className="text-center mt-4 mb-0">
                <Link to="/dashboard">{t('dashboard.return')}</Link>
            </p>
        </Col>
    );
};

export default BookingConfirmed;
